import { EPIC_END } from './constants';

export var epicEnd = function epicEnd() {
  return { type: EPIC_END };
};